import React, { Component } from 'react';
import {connect} from 'react-redux';

import yaml from 'js-yaml';

import SplitPanel from './SplitPanel';
import Pane from './Pane';
import Scrollable from './Scrollable';
import DocView from './DocView';
import {Tabs, Tab, Dialog, RaisedButton} from 'material-ui';

const label_style = {paddingRight: '10px', paddingBottom: '10px', width: '200px', display: 'inline-block', whiteSpace: 'pre'};

const Field = props => {
  const {label, value, format, indent = ''} = props;
  const result = format ? format(value) : value;
  return result === undefined ? null :
    <div>
      <span style={label_style}>{indent}{label}</span>
      <span>{indent}{result}</span>
    </div>;
};

const format_time = val => `${(val / 1000).toFixed(3)}s`;

class ResponsePopup extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      selected: 'response'
    };
  }

  onChange(tab) {
    this.setState({
      selected: tab.props.value
    });
  }

  render() {
    const {saveExample, closeResponsePopup, visible, last} = this.props;
    const onChange = this.onChange.bind(this);

    if (!visible) { return null; }

    const {request, response} = last;

    const key_priorities = {
      method: 1,
      route: 2,
      status: 2,
      headers: 3,
      query: 4,
      body: 5
    };

    const request_filters = ['id', 'time', 'path'];
    const response_filters = ['id', 'time', 'elapsed'];

    const sorter = (key1, key2) => {
      const key1_val = key_priorities[key1] || Infinity;
      const key2_val = key_priorities[key2] || Infinity;
      if (key1_val < key2_val) return -1;
      if (key1_val > key2_val) return 1;
      if (key1_val !== Infinity) return 0;
      if (key1 < key2) return -1;
      if (key2 < key1) return 1;
      return 0;
    };

    const content_type = response.headers['content-type'] || 'text/plain';
    const is_html_response = content_type.indexOf('text/html') !== -1;
    if (is_html_response) {
      response_filters.push('body');
    }

    const inject_base_tag = html => html.replace('<head>', `<head><base href=${request.base_url}${request.route}>`);

    const request_doc = yaml.dump(_.omit(request, request_filters), {sortKeys: sorter});
    const response_doc = yaml.dump(_.omit(response, response_filters), {sortKeys: sorter});

    const dialog_style = {maxWidth: 'none', maxHeight: 'none', width: '90%', height: '90%', backgroundColor: '#fff'};

    const actions = [
      <a onClick={() => saveExample(request, response)} className="btn btn-default api-info__schema-popup-button">Save Example</a>,
      <a onClick={closeResponsePopup} className="btn btn-primary api-info__schema-popup-button">CLOSE</a>
    ];

    const dialog_title = `${request.method.toUpperCase()} ${request.base_url}${request.route}`;

    return <Dialog contentStyle={dialog_style} title={dialog_title} onRequestClose={closeResponsePopup}
                   open={visible} actions={actions} autoScrollBodyContent>
      {response.status >= 500 && response.status <= 599 && <div className="text-danger server-error-message">* Unknown server error has occurred, Please try again after some time.</div>}
      <Tabs style={{minHeight: '900px', backgroundColor:'#fff'}} value={this.state.selected}>
        <Tab label='Request' value='request' onActive={onChange} style={{backgroundColor:'ivory',color:'#000',border:'1px solid #eee'}}>
          <Scrollable>
            <DocView
              theme='base16-light'
              content={request_doc}
              readOnly
              lineNumbers={false}
              lint={false}
              style={{backgroundColor:'#fff'}}/>
          </Scrollable>
        </Tab>
        <Tab label='Response' value='response' onActive={onChange} style={{backgroundColor:'ivory',color:'#000',border:'1px solid #eee'}}>
          <Scrollable>
            <DocView
              style={{height: 'auto',backgroundColor:'#fff'}}
              theme='base16-light'
              content={response_doc}
              readOnly
              lineNumbers={false}
              lint={false}
              />
            {is_html_response ?
              <iframe style={{width: '200%', height: '100%'}} srcDoc={inject_base_tag(response.body)}/> : null
            }
          </Scrollable>
        </Tab>
      </Tabs>
    </Dialog>;
  }
}

export default connect(
  state => ({
    visible: state.getIn(['requests', 'popup'], false),
    last: state.getIn(['requests', 'history']).last()
  }),
  dispatch => ({
    saveExample(request, response) {
      dispatch({type: 'ADD_EXAMPLE', data: {request, response}});
    },
    closeResponsePopup() {
      dispatch({type: 'CLOSE_RESPONSE_POPUP'});
    }
  })
)(ResponsePopup);
